export default __webpack_public_path__ + "static/media/Faster_Does_It.82fb69b7.mp3";